import React, { createContext, useContext, useMemo, useState, useCallback } from 'react';

const SettingsWizardContext = createContext(null);

const createEmptyWizardState = () => ({
  categoryName: '',
  categoryType: '',
  tatMinutes: '',
  template: '',
  visibilityType: '',
  urlLink: '',
  active: false,
  description: '',
  roles: [],
  departmentRows: [
    { id: '1', department: '', subDepartment: '', roles: '' },
  ],
  priorityDraft: '',
  priorities: [],
  defaultPriorityId: null,
  selectedDeptNode: null,
  workflow: {
    name: '',
    tatMinutes: '',
    description: '',
    statuses: [],
    steps: [],
  },
  fieldDraft: { name: '', type: '' },
  formFields: [],
});

export function SettingsWizardProvider({ children, initialValues }) {
  const [state, setState] = useState(() => ({
    ...createEmptyWizardState(),
    ...initialValues,
    workflow: {
      ...createEmptyWizardState().workflow,
      ...initialValues?.workflow,
    },
  }));

  const update = useCallback((patch) => {
    setState((prev) => ({ ...prev, ...patch }));
  }, []);

  const updateWorkflow = useCallback((patch) => {
    setState((prev) => ({
      ...prev,
      workflow: { ...prev.workflow, ...patch },
    }));
  }, []);

  const value = useMemo(
    () => ({ state, setState, update, updateWorkflow }),
    [state, update, updateWorkflow],
  );

  return (
    <SettingsWizardContext.Provider value={value}>
      {children}
    </SettingsWizardContext.Provider>
  );
}

// Context hook co-located with provider (standard React pattern).
// eslint-disable-next-line react-refresh/only-export-components
export function useSettingsWizard() {
  const ctx = useContext(SettingsWizardContext);
  if (!ctx) {
    throw new Error('useSettingsWizard must be used within SettingsWizardProvider');
  }
  return ctx;
}

export default SettingsWizardContext;
